import React from 'react';
import { PropTypes } from 'prop-types';
import { Route } from 'react-router-dom';

const RedirectButton = ({
  to,
  title,
  className,
  tooltip,
  hint,
  redirectBack,
  disabled
}) => (
  <Route
    render={ ({ history }) => (
      <button
        type="button"
        className={ `btn btn-redirect ${ className } ${ tooltip ? 'tooltip' : '' }` }
        onClick={ () => {
          if (redirectBack) {
            return history.goBack();
          }
          return history.push(to);
        } }
        data-tooltip={ tooltip }
        title={ hint }
        disabled={ disabled }
      >
        { title }
      </button>
    ) }
  />
);

RedirectButton.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  hint: PropTypes.string,
  redirectBack: PropTypes.bool,
  disabled: PropTypes.bool
};

RedirectButton.defaultProps = {
  className: '',
  tooltip: null,
  hint: null,
  redirectBack: false,
  disabled: false
};

export default RedirectButton;
